/**
 * Pousse les flags serveur dans window.__OSCOP_FEATURE_FLAGS__ et force un re-render
 * du parent via onVersionChange(configVersion) à chaque update.
 *
 * À placer HAUT dans la hiérarchie des pages protégées (après <AuthContext>).
 */
import { useEffect } from "react";
import { useFeatureFlags } from "@/lib/useFeatureFlags";

export default function FeatureFlagsBootstrap({ onVersionChange }) {
  const { flags } = useFeatureFlags();

  useEffect(() => {
    if (!flags) return;
    try {
      // Pousse les flags serveur dans window pour que isFeatureEnabled() les voie.
      window.__OSCOP_FEATURE_FLAGS__ = flags.flags || {};
    } catch (_) {}
    if (onVersionChange && typeof flags.config_version !== "undefined") {
      onVersionChange(flags.config_version);
    }
  }, [flags, onVersionChange]);

  return null;
}
